module.exports = __webpack_public_path__ + "static/media/coffee_free_en.8a4bf653.jpg";